export default __webpack_public_path__ + "static/media/2412304.bb583755.webp";